import { deleteItem } from "../../api/SessionServiceManager";
import { unpairCameraEndPoint } from "../../configuration";
import { LICENSE_VALUES, LICENSE_TYPES, BASE_LICENSE_SKUS, getActiveLicenseSku } from "../constants/licensesConstants";
import { DEVICE_STATUS_DISPLAY, FW_UPGRADE_STATE } from "../constants/tableConstants";
import { getFovDetailedStatus } from "./Utils";
export const getFieldOfVisions = (cameraId, fovList) => {
  let streamsList = [];
  fovList?.forEach((item) => {
    if (item.parentdeviceid === cameraId) {
      streamsList.push(item.name);
    }
  });
  return streamsList;
};

export const getFieldOfVisionsByFieldName = (fieldName, cameraId, fovList) => {
  let streamsListState = [];
  fovList.forEach((item) => {
    if (item.parentdeviceid === cameraId) {
      streamsListState.push(item[fieldName]);
    }
  });
  return streamsListState;
};

export const getFOVIds = (cameraId, fovList) => {
  let streamsIdList = [];
  fovList?.forEach((item) => {
    if (item.parentdeviceid === cameraId) {
      streamsIdList.push(item.id);
    }
  });
  return streamsIdList;
};

export const getChildFOVId = (cameraId, fovList, fov) => {
  let streamsIdList = [];
  fovList?.forEach((item) => {
    if (item.parentdeviceid === cameraId && item.name === fov) {
      streamsIdList.push(item.id);
    }
  });
  return streamsIdList.length ? [...streamsIdList][0] : [];
};

export const getParentDeviceName = (id, parentList) => {
  const item = parentList?.find((element) => element.id === id);
  return item ? item.name : null;
};

export const flattenValues = (obj) => {
  return Object.values(obj)
    .flatMap((value) => {
      if (value && value[0]?.id) {
        return Array.isArray(value[0].id) ? value[0].id.join(" ") : value[0].id;
      }
      return Array.isArray(value) ? value.join(" ") : value;
    })
    .join(" ")
    .toLowerCase();
};

export const getConvertedDateFormat = (oldDateFormat) => {
  const date = new Date(oldDateFormat);

  const options = { month: "short", day: "numeric", year: "numeric" };
  let formattedDate = date.toLocaleDateString("en-US", options);
  formattedDate = formattedDate.replace(
    /\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sept|Oct|Nov|Dec)\b/,
    "$1."
  );

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12;

  return `${hours}:${minutes} ${ampm}, ${formattedDate}`;
};

export const getCameraObjectbyId = (cameraId, cameraList) => {
  const filteredCameras = cameraList?.filter((item) => item.id === cameraId);
  return filteredCameras;
};

export const getCompanionObjectByRefId = (companionId, companionList) => {
  if (companionList?.length > 0) {
    const filteredCompanionDevices = companionList?.filter(
      (item) => item.refid === companionId
    );
    return filteredCompanionDevices;
  } else {
    return null;
  }
};

export const getCompanionObjectById = (companionId, companionList) => {
  if (!Array.isArray(companionList)) return undefined;
  return companionList.find((item) => item.id === companionId);
};

export const getCompanionObjectbyId = (parentId, itemList) => {
  const filteredItems = itemList.filter((item) => item.id === parentId);
  return filteredItems;
};

export const getFovObjWithStreamId = (fovId, fovList) => {
  return fovList
    .filter((item) => item.id === fovId)
    .map((item) => {
      // Prefer active primary SKU from licenses array (kept in sync by
      // changeLicenseTypeSaga). Fall back to licensesinfo for legacy data.
      const activeSku = getActiveLicenseSku(item?.licenses);
      return {
        ...item,
        licenses: activeSku
          ? [activeSku]
          : item?.licensesinfo?.filter((lic) => lic?.licensetype === LICENSE_TYPES.STANDARD && lic?.sku)?.map((lic) => lic?.sku) || [],
      };
    });
};

export const transformLocation = (data) => {
  return data?.map((item) => {
    if (!item.Location || typeof item?.Location !== "object") {
      return {};
    }

    const transformedLocation = {};
    for (const key in item?.Location) {
      const { name, tag } = item?.Location[key];
      transformedLocation[key] = {
        name: name ? name : "",
        text: name ? name : "",
        value: name ? name : "",
        id: tag ? tag : "",
      };
    }
    return transformedLocation;
  });
};

export const getFilterOptions = (columnData, key, page) => {
  if (page === "cameraTab" && key === "Status") {
    return [
      { text: "Online", value: "Online", name: "Online" },
      { text: "Offline", value: "Offline", name: "Offline" },
      { text: "Calibrating", value: "Calibrating", name: "Calibrating" },
      {
        text: "Not Calibrated",
        value: "Not Calibrated",
        name: "Not Calibrated",
      },
    ];
  }
  if (key === "Status") {
    return [
      { text: "Online", value: "Online", name: "Online" },
      { text: "Offline", value: "Offline", name: "Offline" },
      { text: "Pending", value: "Pending", name: "Pending" },
    ];
  }
  if (key === "site" || key === "role") {
    if (Array.isArray(columnData)) {
      const options = columnData
        .filter((item) => item?.id && item?.name)
        .map((item) => ({
          text: item.name,
          value: item.id,
          name: item.name,
        }));
      return [...new Map(options.map((item) => [item.value, item])).values()];
    }
  }
  if (page === "cameraTab" && key === "Location") {
    const listValues = transformLocation(columnData);
    return listValues;
  }
  const listValues = [...new Set(columnData?.map((item) => item[key]))];
  if (typeof listValues === "object") {
    const filterItems = [...new Set(listValues.flatMap((item) => item))];
    return filterItems.map((value) => ({ text: value, value, name: value }));
  }
  return listValues.map((value) => ({ text: value, value, name: value }));
};

export const getFilteredData = (value, record, key) => {
  if (record[key]?.includes(value)) {
    return record[key]?.includes(value);
  }
};

export const handleDelete = async (
  cameraList,
  record,
  deviceList,
  activeSession
) => {
  try {
    const cameraObj = getCameraObjectbyId(record.CameraId, cameraList)[0];
    const companion = getCompanionObjectbyId(
      cameraObj.parentdeviceid,
      deviceList
    )[0];
    let companionidentifier = {};
    companionidentifier[companion.refidtype] = companion?.refid;
    let cameraidentifier = {};
    cameraidentifier[cameraObj.refidtype] = cameraObj?.refid;
    const body = {
      accountname: activeSession.accountId,
      companionidentifier: companionidentifier,
      cameraidentifier: cameraidentifier,
    };
    const response = await deleteItem(unpairCameraEndPoint(), body);
    if (response.statusText === "OK") {
      // Update the state to remove the deleted record
      const updatedList = deviceList.filter((item) => item.id !== record.id);
      return updatedList;
    } else {
      console.error("Failed to unpair camera");
    }
  } catch (error) {
    console.error("Error unpairing camera:", error);
  }
};

export const isNewBadge = (lastUpdatedDate) => {
  const lastCreatedOnDate = new Date(lastUpdatedDate);
  const now = new Date();
  const diffInMs = now - lastCreatedOnDate;
  const diffInHours = diffInMs / (1000 * 60 * 60);

  return diffInHours < 24;
};

export const getSnapshotImageId = (cameraId, fovList) => {
  let StreamIdList = getFOVIds(cameraId, fovList);
  let snapshot = [];
  StreamIdList.forEach((item) => {
    fovList.forEach((fov) => {
      if (fov.id === item) {
        if (fov?.customdata?.snapshot) {
          snapshot.push(fov?.customdata?.snapshot);
        }
      } else {
        return null;
      }
    });
  });
  return snapshot;
};

export const getCameraNameFromFovId = (fovItem, cameraList, obj) => {
  const result = cameraList?.find(
    (item) => item?.id === fovItem?.parentdeviceid
  )?.[obj];
  return result;
};

export const getLocationFromFovId = (fovItem, cameraList) => {
  return cameraList?.find((item) => item?.id === fovItem?.parentdeviceid)
    ?.customdata?.location;
};

export const getCompanionNameFromId = (companionId, companionList) => {
  return companionList?.find((item) => item?.id === companionId)?.name;
};

export const getCameraDataSource = (cameraList, fovList, companionList) => {
  if (!cameraList || cameraList.length === 0) {
    return null;
  }
  const result = [];
  cameraList.forEach((camera) => {
    const cameraFovs = fovList?.filter(fov => fov.parentdeviceid === camera.id) || [];
    if (cameraFovs.length > 0) {
      cameraFovs.forEach((fovItem) => {
        result.push({
          key: fovItem.id,
          Camera: camera.name,
          CameraId: camera.id,
          CompanionId: camera.parentdeviceid,
          Companion: getCompanionNameFromId(camera.parentdeviceid, companionList),
          lastUpdatedDate: camera.createdon,
          Streams: fovItem?.name,
          StreamId: fovItem?.id,
          Location: camera?.customdata?.location,
          siteSelected: camera?.customdata?.location?.site,
          floorSelected: camera?.customdata?.location?.floor,
          areaSelected: camera?.customdata?.location?.area,
          subAreaSelected: camera?.customdata?.location?.subarea,
          Snapshot: fovItem?.customdata?.imageid,
          Status: fovItem?.state,
          fields: fovItem?.fields,
          license: fovItem?.licensesinfo?.filter((lic) => lic?.licensetype === LICENSE_TYPES.STANDARD && lic?.sku)?.map((lic) => lic?.sku) || [],
          connectivityStatus: fovItem?.connectivityStatus ?? "",
          isManualAdded: (() => {
            const cameraFirstFovMode = camera?.fovs?.[0]?.customdata?.mode;
            const fovCustomMode = fovItem?.customdata?.mode;
            return cameraFirstFovMode === "manual" || fovCustomMode === "manual" ? true : false;
          })(),
          Apps: null,
          licensesinfo: fovItem?.licensesinfo,
          licenseStatus: fovItem?.licensesinfo?.find((lic) => lic?.licensetype === LICENSE_TYPES.STANDARD)?.status?.toLowerCase() ?? ""
        });
      });
    } else {
      result.push({
        key: camera.id,
        Camera: camera.name,
        CameraId: camera.id,
        CompanionId: camera.parentdeviceid,
        Companion: getCompanionNameFromId(camera.parentdeviceid, companionList),
        lastUpdatedDate: camera.createdon,
        Streams: "No Streams",
        StreamId: null,
        Location: camera?.customdata?.location,
        siteSelected: camera?.customdata?.location?.site,
        floorSelected: camera?.customdata?.location?.floor,
        areaSelected: camera?.customdata?.location?.area,
        subAreaSelected: camera?.customdata?.location?.subarea,
        Snapshot: null,
        Status: camera?.state || "Unknown",
        fields: camera?.fields,
        license: [],
        connectivityStatus: camera?.connectivityStatus ?? "",
        isManualAdded: camera?.fovs?.[0]?.customdata?.mode === "manual" ? true : false,
        Apps: null,
        licenseStatus: camera?.fovs?.[0]?.licensesinfo?.[0]?.status?.toLowerCase(),
      });
    }
  });

  return result;
};

export const getSiteDetails = (siteids, sites) => {
  if (siteids) {
    const siteId = siteids[0];
    const site = sites?.find((site) => site?.id === siteId);
    return site ? site?.name : "Not Available";
  } else {
    return "Not Available";
  }
};

export const getCompanionDataSource = (companionList, sites, ccdUpdateList) => {
  if (
    companionList &&
    Array.isArray(companionList) &&
    companionList?.length > 0
  ) {
    return companionList?.map((companionItem) => {
      // Find matching update in ccdUpdateList by id
      const updateObj = Array.isArray(ccdUpdateList)
        ? ccdUpdateList.find((ccd) => ccd.id === companionItem.id)
        : undefined;
         let status;
      if (updateObj && updateObj.fields) {
        const eta = updateObj?.fields?.fw_eta_state_upgrade;
        const fwState = updateObj?.fields?.fw_state_upgrade;
        if (eta === 0 && fwState?.toLowerCase() === FW_UPGRADE_STATE.SUCCESS) {
          status = DEVICE_STATUS_DISPLAY.ONLINE;
        } else if (eta && fwState?.toLowerCase() === FW_UPGRADE_STATE.INPROGRESS) {
          status = FW_UPGRADE_STATE.INPROGRESS;
        } else {
          status = companionItem?.fields?.connectivityStatus ?? DEVICE_STATUS_DISPLAY.OFFLINE;
        }
      } else {
        status = companionItem?.fields?.connectivityStatus ?? DEVICE_STATUS_DISPLAY.OFFLINE;
      }
      return {
        Name: companionItem?.name,
        Status: status,
        Location: getSiteDetails(companionItem?.siteids, sites),
        SiteIds: companionItem?.siteids ? companionItem?.siteids : null,
        Firmware: updateObj?.fields?.ccdversion
          ? updateObj?.fields?.ccdversion
          : companionItem?.softwareversion
          ? companionItem?.softwareversion
          : "NA",
        Lastupdated: companionItem?.fields?.connectivityStatusLastUpdate
          ? getConvertedDateFormat(
              companionItem?.fields?.connectivityStatusLastUpdate
            )
          : "NA",
        Id: companionItem.refid,
        LastUpdatedOn: companionItem.createdon,
        TagIds: companionItem?.tagids ? companionItem?.tagids : null,
        ETA: updateObj?.fields?.fw_eta_state_upgrade ?? null,
      };
    });
  } else {
    return null;
  }
};

export const getStreamForUnpaired = (Streams, discoveredCamera) => {
  if (Streams?.length > 1) {
    return Streams?.map((stream) => ({
      Streams: [stream?.fovID],
      Snapshot: discoveredCamera.fov,
      resourceidentifier: discoveredCamera.resourceidentifier,
      id: discoveredCamera.qrcode,
    }));
  } else {
    return null;
  }
};

export const getUnpairedStreams = (Streams) => {
  const streamList = [];
  Streams?.forEach((stream) => {
    streamList.push(stream?.fovID);
  });
  return streamList;
};

export const getUnpairedCameraDataSource = (
  unpairedCameraList,
  companionDeviceList
) => {
  if (unpairedCameraList?.length > 0) {
    return unpairedCameraList.flatMap((item) =>
      item.fovs.length > 0
        ? item.fovs.map((fov) => ({
            CameraId: item.qrcode,
            Key: item.qrcode,
            Location: item?.customdata?.location?.site?.name || "Not Available",
            DiscoveredTime: getConvertedDateFormat(
              companionDeviceList.find((m) => m.id == item.discoveredby)
                .customdata?.lastDiscoveredTime
            ),
            resourceidentifier: item?.resourceidentifier,
            discoveredby: item?.discoveredby,
            Streams: fov.fovID,
            StreamsList: getUnpairedStreams(item.fovs),
            Snapshot: item.fov,
            Companions: companionDeviceList.find(
              (m) => m.id == item.discoveredby
            ).name,
          }))
        : []
    );
  } else {
    return null;
  }
};
